import React from 'react'

const FrameComponent = ({source, height, width}) => {
  return (
    <div class="embed-responsive embed-responsive-16by9">
        <iframe class="embed-responsive-item" src={source} height={height} width={width} allowfullscreen></iframe>
    </div>
  )
}

export default FrameComponent